<div>
  <div class="modal-content">
    <div class="modal-header">
      <h2>Weet je het zeker?</h2>
      <button (click)="close()">&times;</button>
    </div>
    <hr>
    <div class="modal-message">
      <p *ngIf="actionType == 'Admin' && adminBool">Weet je zeker dat je de adminrechten van de geselecteerde gebruiker admin wilt ontnemen?</p>
      <p *ngIf="actionType == 'Admin' && !adminBool">Weet je zeker dat je de geselecteerde gebruiker adminrechten wilt geven? Met adminrechten kan de gebruiker ook toegang krijgen tot deze omgeving.</p>
      <p *ngIf="actionType == 'Activate' && activateBool">Weet je zeker dat je de geselecteerde gebruiker wilt deactiveren? Deze gebruiker kan dan niet meer inloggen.</p>
      <p *ngIf="actionType == 'Activate' && !activateBool">Weet je zeker dat je de geselecteerde gebruiker wilt activeren?</p>
    </div>
    <div class="modal-buttons">
      <button class="cancel-button" (click)="close()">Terug</button>
      <button class="signup-button" *ngIf="actionType == 'Admin' && adminBool" (click)="toggleField()">Adminrechten ontnemen</button>
      <button class="signup-button" *ngIf="actionType == 'Admin' && !adminBool" (click)="toggleField()">Adminrechten geven</button>
      <button class="signup-button" *ngIf="actionType == 'Activate' && activateBool" (click)="toggleField()">Gebruiker deactiveren</button>
      <button class="signup-button" *ngIf="actionType == 'Activate' && !activateBool" (click)="toggleField()">Gebruiker activeren</button>
    </div>
  </div>
</div>
